export default function DataProtection() {
    return <div>
        <h2>Hinweise zum Datenschutz gemäß Datenschutz-Grundverordnung (DSGVO)</h2>
        <p>Die erhobenen Daten werden streng vertraulich und ausschließlich zu wissenschaftlichen Zwecken verarbeitet
            und in anonymisierter Form gemäß den Empfehlungen der Deutschen Forschungsgemeinschaft (DFG)
            für mindestens zehn Jahre in gesicherten Systemen in Deutschland gespeichert.
            Nach Abschluss der Studie werden die dann vollständig anonymisierten Daten ggf.
            als offene Daten im Internet in einem gesicherten Datenarchiv zugänglich gemacht.
            Eine Nachnutzung der Daten im Rahmen der wissenschaftlichen Forschung, die über den primären Erhebungsgrund hinausgehen,
            ist dabei eingeschlossen.
        </p>
        <p>
        Die Anwendung wird auf internen Servern am IPN gehostet.
            Die in der digitalen Lernplattform erfassten Daten
            (IP-Adresse, Aufgabenlösungen, Anforderungen von Hilfe, Mausbewegungen bei der Aufgabenlösung)
            werden zur Verarbeitung an Google Dienste gesendet, die in der EU betrieben werden.
            Die IP Adresse wird aus technischen Gründen erhoben,
            wird jedoch nicht für die wissenschaftlichen Analysen ausgewertet.
        </p>
        <p>
        Für alle weiteren datenschutzrechtlichen Anliegen und Wahrnehmungen Ihrer Rechte
            wenden Sie sich bitte an <a href="mailto:datenschutz@leibniz-ipn.de">datenschutz@leibniz-ipn.de</a>.
        Des Weiteren haben Sie ein Recht auf Beschwerde beim Unabhängigen Landeszentrum
            für Datenschutz Schleswig-Holstein, Holstenstraße 98, 24103 Kiel,
            mail@datenschutzzentrum.de.
        </p>
        <p>
        Name der datenverarbeitenden Forschungseinrichtung
        IPN – Leibniz-Institut für die Pädagogik der Naturwissenschaften und Mathematik Olshausenstraße 62 • 24118 Kiel
        Vertreten durch den Datenschutzbeauftragten
            Dr. Tim Höffler (Datenschutzbeauftragter, E-Mail: <a href="mailto:datenschutz@leibniz-ipn.de">datenschutz@leibniz-ipn.de</a>)
            Studienverantwortliche
            Prof. Dr. Olaf Köller
        Studienleitende (Verantwortlich für Datenspeicherung)
        Prof. Dr. Olaf Köller
        Kontaktdaten
        IPN Kiel • Olshausenstraße 62 • 24118 Kiel, E-Mail: <a href="mailto:koeller@leibniz-ipn.de">koeller@leibniz-ipn.de </a>
            Zuständige Aufsichtsbehörde
            Landesbeauftragte für Datenschutz Schleswig-Holstein, Marit Hansen • Holstenstraße 93 • 24103 Kiel
        </p>
    </div>
}